import React from "react";

export interface IAuthContext {
	isLoggedIn: boolean;
	gigyaAccount: IGigyaAccount | null;
	loading: boolean;
}

export interface IGigyaAccount {
	UID: string;
	UIDSignature: string;
	data: {
		CDCEmail: string;
		UID: string;
		additionalEmail: string;
		department: string;
		docNumber: string;
		docType: string;
		idAlma: string;
		mobile: string;
		optimy_lang: string;
		phone: string;
		regToken: string;
		secondLastName: string;
		secondName: string;
		state: string;
		userVerification: boolean
		validationCode: string;
		validationSel: string;
		verifiedAdditionalEmail: boolean
		verifiedEmail: boolean
		verifyingEmail: string;
		verifyingMobile: string;
	}
	profile: {
		age: number;
		birthDay: number;
		birthMonth: number;
		birthYear: number;
		city: string;
		country: string;
		email: string;
		firstName: string;
		gender: string;
		lastName: string;
		photoURL: string;
		thumbnailURL: string;
	}
	status: string;
	statusMessage: string;
	time: string;
	verified: string;
	verifiedTimestamp: string;
}

export default React.createContext({} as IAuthContext);